


import React from 'react';
import './concernsSection.css';

const ConcernsSection = ({ data = {} }) => {
  const fifthsub = data.fifthsub || [];

  // "Lung Health Concerns" → last word in green
  const headingWords  = (data.heading || "").trim().split(" ");
  const headingAccent = headingWords.length > 1 ? headingWords.pop() : "";
  const headingMain   = headingWords.join(" ");

  return (
    <section className="bg-white py-10 md:py-14">
      <div className="mx-auto px-[14px] md:px-[28px] lg:px-[60px] xl:px-[max(60px,calc(50%_-_660px))]">
        
        {/* 🔹 Icon + Small Title */}
        {/* <div className="inline-flex items-center gap-2 bg-[#F4F9FF] border border-gray-100 rounded-full px-6 py-2 mb-3">
          {data.iconurl && (
            <img
              src={data.iconurl}
              alt="icon"
              className="w-5 h-5 object-contain"
            />
          )}
          <span className="text-sm font-medium text-[#0C1B4D]">
            {data.icondesc}
          </span>
        </div> */}

        {/* 🔹 Main Heading */}
        <h2 className="cb-concerns-heading">
          {headingMain}{headingAccent && " "}
          {headingAccent && <span className="cb-concerns-heading-accent">{headingAccent}</span>}
        </h2>

        {/* 🔹 Concerns Grid - Single Line for 5 items */}
        <div className="flex flex-wrap justify-around gap-6 md:gap-10 mt-8">
          {fifthsub.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center w-[120px] sm:w-[140px]"
            >
              
              {/* 🔹 Circle Image (green ring is part of the image itself) */}
              <div className="w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] lg:w-[144px] lg:h-[144px] rounded-full overflow-hidden mb-3 sm:mb-4">
                {item.imgurl && (
                  <img
                    src={item.imgurl}
                    alt={item.subheading}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>

              {/* 🔹 Subheading */}
              <h3 className="text-sm sm:text-base font-medium text-[#1E1E1E] leading-tight">
                {item.subheading}
              </h3>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ConcernsSection;